import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $totalCountOfTransactions,
  $transactions,
  getTransactions,
  transactionsListMounted,
} from './model'
import { TransactionRequest } from './types'

export const useTransactionsList = () => {
  const onChangeTransactionsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: TransactionRequest) => {
    transactionsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const transactions = useStore($transactions)
  const totalCountOfTransactions = useStore($totalCountOfTransactions)
  const loading = useStore(getTransactions.pending)
  return {
    transactions,
    totalCountOfTransactions,
    loading,
    onChangeTransactionsList,
  }
}
